export const getPropertyOwnerFullName = (propertyOwner) =>
  propertyOwner && propertyOwner.fullName ? propertyOwner.fullName : null;
